import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    animation: '$fadeIn 0.3s ease-out',
  },
  overlayClosing: {
    animation: '$fadeOut 0.3s ease-in forwards',
  },
  dialog: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '12px',
    maxWidth: '560px',
    width: '90%',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
    position: 'relative',
    animation: '$slideUp 0.3s ease-out',
  },
  dialogClosing: {
    animation: '$slideDown 0.3s ease-in forwards',
  },
  closeButton: {
    position: 'absolute',
    top: '14px',
    right: '14px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#666',
    padding: '4px',
    borderRadius: '6px',
    lineHeight: 1,
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  title: {
    marginTop: 0,
    marginBottom: '0.75rem',
    fontSize: '1.125rem',
    fontWeight: 600,
    color: '#1a1d29',
  },
  description: {
    marginBottom: '1.25rem',
    color: '#5c5e6e',
    lineHeight: 1.5,
    fontSize: '0.875rem',
  },
  options: {
    marginBottom: '1.75rem',
    fontSize: '0.875rem',
    lineHeight: 1.8,
    color: '#1a1d29',
    backgroundColor: '#f8f9fc',
    padding: '1rem',
    borderRadius: '8px',
  },
  option: {
    marginBottom: '0.5rem',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'flex-end',
  },
  buttonSecondary: {
    padding: '0.625rem 1.25rem',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#fff',
    color: '#424242',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#c0c0c0',
    },
  },
  buttonPrimary: {
    padding: '0.625rem 1.25rem',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#4c4cff',
    color: 'white',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#3b3be0',
    },
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  spinner: {
    width: '14px',
    height: '14px',
    border: '2px solid rgba(255,255,255,0.3)',
    borderTopColor: 'white',
    borderRadius: '50%',
    animation: '$spin 0.6s linear infinite',
  },
  '@keyframes spin': {
    to: { transform: 'rotate(360deg)' },
  },
  '@keyframes slideUp': {
    from: { transform: 'translateY(100%)' },
    to: { transform: 'translateY(0)' },
  },
  '@keyframes slideDown': {
    from: { transform: 'translateY(0)' },
    to: { transform: 'translateY(100%)' },
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes fadeOut': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
});

export default useStyles;
